import { format } from 'date-fns'

import { DATE_FORMAT } from 'constants/DateFormats'

export const NEVER = 'Never'

export const formatActivityDate = (value?: string | null) =>
  value ? format(new Date(value), DATE_FORMAT) : NEVER
